import React from 'react';
import {
  AboutContainer,
  AboutHeading,
  AboutProfile,
  AboutProfileImage,
  AboutTextSection,
} from '../Styles/StylesAbout.js';
import about from '../Images/about.webp'

function About() {
  return (
    <AboutContainer>
      {/* Heading Section */}
      <AboutHeading>Michael Johnson</AboutHeading>

      {/* Profile Image */}
      <AboutProfile>
        <AboutProfileImage src={about} />
      </AboutProfile>

      {/* About Text Section */}
      <AboutTextSection>
        <p>
          Michael Johnson is a seasoned software engineer with over 12 years of
          experience in developing innovative solutions for the tech industry.
          He currently works as a Lead Developer at a cutting-edge AI company,
          where he focuses on building scalable applications and mentoring a
          team of talented engineers.
        </p>
        <p>
          Throughout his career, Michael has led multiple high-impact projects,
          including the development of cloud-based platforms and AI-powered
          tools that have streamlined processes for Fortune 500 companies. His
          expertise lies in full-stack development, cloud computing, and
          artificial intelligence.
        </p>
        <p>
          Michael is a strong advocate for open-source contributions and has
          authored several popular libraries used by developers worldwide. He
          regularly speaks at tech conferences, sharing insights into emerging
          technologies and best practices in software engineering.
        </p>
        <p>
          Education: Bachelor’s in Computer Science from MIT; certifications in
          Machine Learning and Cloud Architecture.
        </p>
        <p>
          In his personal time, Michael enjoys woodworking, hiking, and playing
          the guitar. He is an active community volunteer, teaching coding
          workshops to underprivileged youth. Michael resides in Seattle with
          his wife, Emma, and their two children, Lucas and Olivia.
        </p>
      </AboutTextSection>
    </AboutContainer>
  );
}

export default About;
